/**
 * 生成指定长度的随机字符串。
 *
 * @param {number} [length=6] - 随机字符串的长度，默认为 6。
 * @returns {string} 生成的随机字符串。
 *
 * @example
 * // 使用示例：
 * const generatedString = randomString(8);
 * console.log(generatedString);
 * // 输出: 'aB5x9pRt'
 */
export default function randomString(length?: number): string {
  const e = length || 6
  const t = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678',
    a = t.length
  let n = ''
  for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a))
  return n
}
